export const formatDate = (dateString) => {
    const date = new Date(dateString);
    
    // Format as "Month DD, YYYY"
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };